import { Translations } from '../models';

const getTranslations = <T extends Translations>(translations: T): T => translations;

export const TRANSLATIONS = getTranslations({
    'footer': {
        'contactUs': [
            'Contact us',
            'Kontakt'
        ],
        'contactUsLink': [
            'http://new.siemens.com/global/en/general/contact.html',
            'https://new.siemens.com/global/de/general/kontakt.html'
        ],
        'cookieNotice': [
            'Cookie Notice',
            'Cookie-Hinweise'
        ],
        'cookieNoticeLink': [
            'https://new.siemens.com/global/en/general/cookie-notice.html',
            'https://new.siemens.com/global/de/general/cookie-richtlinien.html'
        ],
        'corporateInformation': [
            'Corporate Information',
            'Impressum'
        ],
        'corporateInformationLink': [
            'https://new.siemens.com/global/en/general/legal.html',
            'https://new.siemens.com/global/de/general/legal.html'
        ],
        'digitalId': [
            'Digital ID',
            'Digitales Zertifikat'
        ],
        'digitalIdLink': [
            'https://new.siemens.com/global/en/general/digital-id.html',
            'https://new.siemens.com/global/de/general/digitales-zertifikat.html'
        ],
        'siemensWebsite': [
            'siemens.com Global Website',
            'siemens.com Germany'
        ],
        'siemensWebsiteLink': [
            'https://new.siemens.com/global/en.html',
            'https://new.siemens.com/global/de.html'
        ],
        'privacyNotice': [
            'Privacy Notice',
            'Datenschutz'
        ],
        'privacyNoticeLink': [
            'https://new.siemens.com/global/en/general/privacy-notice.html',
            'https://new.siemens.com/global/de/general/datenschutz.html'
        ],
        'siemens': [
            '© Siemens, 1996 - {date}',
            '© Siemens, 1996 - {date}'
        ],
        'termsOfUse': [
            'Terms of use',
            'Nutzungsbedingungen'
        ],
        'termsOfUseLink': [
            'https://new.siemens.com/global/en/general/terms-of-use.html',
            'https://new.siemens.com/global/de/general/nutzungsbedingungen.html'
        ]
    },
    'header': {
        'language': [
            'Language',
            'Sprache'
        ],
        'languages': {
            'en': [
                'English',
                'English'
            ],
            'de': [
                'Deutsch',
                'Deutsch'
            ]
        },
        'skipToMainContent': [
            'Skip to main content',
            'Skip to main content'
        ],
        'support': [
            'Support',
            'Unterstützung'
        ],
        'reportProblem': [
            'Report a problem',
            'Ein Problem melden'
        ]
    },
    'main': {
        'invalidProduct': [
            'Invalid product',
            'Ungültiges produkt'
        ],
        'digitalNameplate': [
            'Digital nameplate',
            'Digitales typenschild'
        ],
        'entry': [
            'Entry',
            'Beitrag'
        ],
        'entries': [
            'Entries',
            'Beiträge'
        ],
        'supportEntries': [
            'Support entries',
            'Supportbeiträge'
        ]
    },
    'snackbarMessages': {
        'cannotLoadProduct': [
            'Cannot load product',
            'Produkt kann nicht geladen werden'
        ],
        'cannotDownloadDocument': [
            'Cannot download document',
            'Dokument kann nicht heruntergeladen werden'
        ]
    }
});
